import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlightMoney',
  standalone: true,
})
export class HighlightMoneyPipe implements PipeTransform {
  transform(value: string | null): string {
    if (!value) return '';

    const regex = /(\$[\d,.]+|[\d,.]+\s*LEE)/g;

    return value.replace(regex, '<strong>$1</strong>');
  }
}
